/** Top-level collections; each document includes `userId` for ownership. */
export const COLLECTION_FINANCIAL_ITEMS = 'financialItems';
export const COLLECTION_INVESTMENT_ITEMS = 'investmentItems';
export const COLLECTION_COMPANY_UPDATES = 'companyUpdates';
export const COLLECTION_MONTHLY_UPDATES = 'monthlyUpdates';
export const COLLECTION_INVESTMENT_CASES = 'investmentCases';
export const COLLECTION_BUSINESS_OPPORTUNITIES = 'businessOpportunities';
export const COLLECTION_BANK_CONNECTIONS = 'bankConnections';
export const COLLECTION_BANK_ACCOUNTS = 'bankAccounts';
export const COLLECTION_BANK_TRANSACTIONS = 'bankTransactions';
export const COLLECTION_REAL_ESTATE_ITEMS = 'realEstateItems';
export const COLLECTION_NET_WORTH_SNAPSHOTS = 'netWorthSnapshots';
export const COLLECTION_RAG_CHUNKS = 'ragChunks';
export const COLLECTION_CHAT_THREADS = 'chatThreads';
export const COLLECTION_CHAT_MESSAGES = 'chatMessages';
export const COLLECTION_NET_WORTH_SCENARIOS = 'netWorthScenarios';
export const COLLECTION_FOUNDER_UPDATE_INBOX_ITEMS = 'founderUpdateInboxItems';
export const COLLECTION_PORTFOLIO_RADAR_SIGNALS = 'portfolioRadarSignals';
export const COLLECTION_ENTITY_DOCUMENTS = 'entityDocuments';
export const COLLECTION_LEGAL_ENTITIES = 'legalEntities';
export const COLLECTION_OPPORTUNITY_CHAT_MESSAGES = 'opportunityChatMessages';
export const COLLECTION_OPPORTUNITY_CHAT_THREADS = 'opportunityChatThreads';
export const COLLECTION_INVESTMENT_CHAT_MESSAGES = 'investmentChatMessages';
export const COLLECTION_INVESTMENT_CHAT_THREADS = 'investmentChatThreads';
export const COLLECTION_INVESTMENT_CASE_CHAT_MESSAGES = 'investmentCaseChatMessages';
export const COLLECTION_INVESTMENT_CASE_CHAT_THREADS = 'investmentCaseChatThreads';
export const COLLECTION_REAL_ESTATE_CHAT_MESSAGES = 'realEstateChatMessages';
export const COLLECTION_REAL_ESTATE_CHAT_THREADS = 'realEstateChatThreads';

const SEP = '__';

/**
 * Document ID = `{userId}__{itemId}` so rules can bind ownership to path and data.id.
 * Item ids must not contain `__` (seed and app ids use hyphens only).
 */
export function ownedItemDocId(userId: string, itemId: string): string {
  return `${userId}${SEP}${itemId}`;
}
